<script lang="ts">
    import { onMount, onDestroy } from 'svelte';
    import { f7, Icon } from 'framework7-svelte';

    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    export let selectedTime: string | null = null;

    let picker;
    let inputEl: HTMLInputElement;
    let displayEl: HTMLDivElement;

    function handleChangeTime(timeValueAsString: string[]): void {
        selectedTime = timeValueAsString.join(':');
        dispatch('change', selectedTime);
    }

    onMount(() => {
        picker = f7.picker.create({
            inputEl,
            targetEl: displayEl,
            openIn: 'popover',
            rotateEffect: true,
            backdrop: true,
            routableModals: true,
            toolbar: false,
            closeByOutsideClick: true,

            value: selectedTime?.split(':'),

            cols: [
                {
                    values: Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'))
                },
                {
                    divider: true,
                    content: ':'
                },
                {
                    values: Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'))
                }
            ],

            on: {
                close: (picker) => {handleChangeTime(picker.value)},
            }
        });
    });

    onDestroy(() => {
        picker?.destroy();
    });
</script>

<div>
    <div bind:this={displayEl} on:click={() => picker.open()} class="time-display">
        <Icon material="access_time" size="16px" />
        {selectedTime}
        <input bind:this={inputEl} readonly style="width: 100%;pointer-events: none; visibility: hidden; " />
    </div>
</div>

<style>
    .time-display {
        padding: 8px 16px;
        border: 1px solid #ccc;
        border-radius: 10px;
        width: fit-content;
        cursor: pointer;
        background: #fff;
        width: 60px;
        height: 20px;
        margin: 8px;
    }
</style>
